import { IntegrationType, SignatureUrls } from '@nemuru-eng/js-api-client';

import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { RedirectEmbeddedSignature } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/RedirectEmbeddedSignature/RedirectEmbeddedSignature';
import { RedirectSignature } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/RedirectSignature/RedirectSignature';
import { SamlSignature } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/SignContract/Signature/SamlSignature/SamlSignature';

interface SignatureFactoryProps {
  signatureUrls: SignatureUrls;
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
  requiresResignature?: boolean;
  disabled?: boolean;
}

export const SignatureFactory = ({
  signatureUrls,
  paymentMethodDetailEntity,
  requiresResignature,
  disabled,
}: SignatureFactoryProps) => {
  const { integrationType } = signatureUrls;

  const lenderName = paymentMethodDetailEntity.loan?.loanApplicationSelected?.lenderName;

  if (!lenderName) {
    return null;
  }

  switch (integrationType) {
    case IntegrationType.REDIRECT:
    case IntegrationType.EMBEDDED:
      if (paymentMethodDetailEntity.isSignatureEmbeddable(integrationType)) {
        return (
          <RedirectEmbeddedSignature
            signatureUrls={signatureUrls}
            requiresResignature={requiresResignature}
            disabled={disabled}
          />
        );
      }
      return (
        <RedirectSignature
          signatureUrls={signatureUrls}
          lenderName={lenderName}
          requiresResignature={requiresResignature}
          disabled={disabled}
        />
      );
    case IntegrationType.EMBEDDED_SAML:
      return (
        <SamlSignature
          signatureUrls={signatureUrls}
          paymentMethodDetailEntity={paymentMethodDetailEntity}
          disabled={disabled}
        />
      );
  }

  return null;
};
